var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_2731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.374803 13.6647C0.321064 6.23717 6.29851 0.150772 13.726 0.0970337C21.1535 0.0432952 27.2184 6.04257 27.2721 13.4701C27.3258 20.8975 21.3484 26.9839 13.9209 27.0377C6.49342 27.0914 0.428541 21.0921 0.374803 13.6647Z",
    fill: "url(#paint0_linear_2992_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.374803 13.6647C0.320978 6.22521 6.29851 0.150772 13.726 0.0970337C21.1535 0.0432952 27.2183 6.0306 27.2721 13.4701C27.3259 20.9095 21.3484 26.9839 13.9209 27.0377C6.49343 27.0914 0.428628 21.1041 0.374803 13.6647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5708 6.97539L15.5018 6.99035C14.5872 6.99697 13.7127 7.36721 13.0707 8.01963C12.4287 8.67205 12.0718 9.55319 12.0784 10.4692L12.0934 12.5416L10.0244 12.5566L10.0443 15.3197L12.1134 15.3047L12.1534 20.831L14.9121 20.8111L14.8721 15.2848L16.9411 15.2698L17.6108 12.5017L14.8521 12.5216L14.8371 10.4493C14.8358 10.2661 14.9071 10.0898 15.0356 9.95935C15.164 9.82887 15.3388 9.75482 15.5218 9.7535L17.5908 9.73853L17.5708 6.97539Z",
    stroke: "white",
    strokeWidth: 1.40286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2992_2731",
    x1: 21.7058,
    y1: 22.0159,
    x2: 5.32363,
    y2: -0.607097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0571E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A6FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_2731"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.374803 13.6647C0.321064 6.23717 6.29851 0.150772 13.726 0.0970337C21.1535 0.0432952 27.2184 6.04257 27.2721 13.4701C27.3258 20.8975 21.3484 26.9839 13.9209 27.0377C6.49342 27.0914 0.428541 21.0921 0.374803 13.6647Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.fd22710eb3fcd4807cb7ce801ecc3851.svg";
export { ForwardRef as ReactComponent };